import { motion } from 'framer-motion';

interface LogoProps {
  size?: 'small' | 'large';
}

export function Logo({ size = 'large' }: LogoProps) {
  const isSmall = size === 'small';

  return (
    <motion.div
      className={`logo-container ${isSmall ? 'small' : ''}`}
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="logo-badge-wrapper">
        <img
          src="/logo.png"
          alt="Veronica Logo"
          className={`logo-image ${isSmall ? 'logo-image-small' : 'logo-image-large'}`}
        />
      </div>
      {!isSmall && (
        <span className="logo-tagline-badge">
          AI-POWERED SALON RECEPTIONIST
        </span>
      )}
    </motion.div>
  );
}

